
import React from "react";
import { Link } from 'react-router-dom';


function Footer() {
  return (
    <>
       <footer>
        <div className="container">
          <div className="footer-inner">
            <div className="footer-widget">
              <div className="footer-menu">
                <div className="widget-box">
                  <ul>
                    <li><Link as={Link} to="/About">About Library</Link></li>
                    <li><Link as={Link} to="/LibraryServices">Library Services</Link></li>
                    <li><Link as={Link} to="/AskaLibrarian">Ask a Librarian</Link></li>
                  </ul>
                </div>
                <div className="widget-box">
                  <ul>
                    
                  <li><Link as={Link} to="/EventCalendar">Upcoming Events</Link></li>
                    <li><Link as={Link} to="/ResourceRequest">Resource Request Form</Link></li>
                    <li><Link as={Link} to="/Faq">FAQs</Link></li>
                  </ul>
                </div>
              </div>
              <div className="copy-content">
              <div  className="copyright"> 
    <p><a href={"https://habib.edu.pk/"} target="_blank"> Habib University</a>- All Right Reserved<span className="seprator">|</span></p>
    <p>Powered by <a href={"https://habib.edu.pk/huit/"} target="_blank"> HUIT</a></p>
</div>
                <p className="copyright"> <a href={"https://habib.edu.pk/privacy-statement/"} target="_blank"> Privacy Statement</a></p>
              </div>
            </div>
            <div className="footer-right">
              <div className="widget-box">
                <Link to="/" as={Link}>
                  <img src="https://habib.edu.pk/dev-library/assets/img/footer-logo.png" className="img-fluid" alt=""/>
                </Link>
              </div>
              <ul className="social-links">
                <li>
                  <a href="https://www.facebook.com/HabibUniversity">
                    <img src="https://habib.edu.pk/dev-library/assets/img/fa.svg" alt=""/> 

                    </a>
                </li>
                <li>
                <a href="https://www.linkedin.com/company/habib-university">
                    <img src="https://habib.edu.pk/dev-library/assets/img/li.svg" alt=""/> 
                    </a>
                </li>
                <li>
                <a href="https://instagram.com/habibuniversity">
                    <img src="https://habib.edu.pk/dev-library/assets/img/in.svg" alt=""/> 
                    </a>
                </li>
                <li>
                <a href="https://twitter.com/habibuniversity">
                    <img src="https://habib.edu.pk/dev-library/assets/img/tw.svg" alt=""/> 
                    </a>
                </li>
                <li>
                <a href="https://www.youtube.com/user/HabibUni">
                    <img src="https://habib.edu.pk/dev-library/assets/img/yo.svg" alt=""/> 
                    </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </footer>
    </>
  );
}
export default Footer;